  // <script src="https://unpkg.com/aos@next/dist/aos.js"></script

document.addEventListener('DOMContentLoaded', () => {

  // Initialize AOS (Animate on Scroll)
  if (typeof AOS !== 'undefined') {
    AOS.init({
      duration: 800,
      once: true,
      offset: 100,
      easing: 'ease-out-cubic',
         disable: 'mobile' // Disables AOS on mobile devices

    });
  }

  // // Mobile Menu Toggle
  // const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
  // const navLinks = document.querySelector('.nav-links');
  
  // if (mobileMenuBtn && navLinks) {
  //   mobileMenuBtn.addEventListener('click', () => {
  //     navLinks.style.display = navLinks.style.display === 'flex' ? 'none' : 'flex';
  //     navLinks.style.flexDirection = 'column';
  //     navLinks.style.position = 'absolute';
  //     navLinks.style.top = '100%';
  //     navLinks.style.left = '0';
  //     navLinks.style.width = '100%';
  //     navLinks.style.backgroundColor = 'var(--bg-dark)';
  //     navLinks.style.padding = '20px';
  //     navLinks.style.borderBottom = '1px solid var(--primary-color-rgba-light)';
  //     navLinks.style.zIndex = '99';
  //   });
  // }

  // Tabs Functionality
  const tabBtns = document.querySelectorAll('.tab-btn');
  const tabContents = document.querySelectorAll('.tab-content');

  if (tabBtns.length > 0 && tabContents.length > 0) {
    tabBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        // Remove active class from all buttons and contents
        tabBtns.forEach(b => b.classList.remove('active'));
        tabContents.forEach(c => c.classList.remove('active'));

        // Add active class to clicked button
        btn.classList.add('active');

        // Show corresponding content
        const targetId = btn.getAttribute('data-target');
        const targetContent = document.getElementById(targetId);
        if (targetContent) {
          targetContent.classList.add('active');
        }
      });
    });
  }

  // Initialize Splide for Testimonials
  if (typeof Splide !== 'undefined') {
    const testimonialSlider = document.querySelector('.splide');
    if (testimonialSlider) {
      new Splide(testimonialSlider, {
        type: 'loop',
        perPage: 3,
        perMove: 1,
        gap: '30px',
        pagination: true,
        arrows: true,
        breakpoints: {
          1024: {
            perPage: 2,
          },
          768: {
            perPage: 1,
          }
        }
      }).mount();
    }
  }
});
